<template>
  <div class="topic-box" :class="bgColor">
    <p class="title">
      <span v-if="itemData.isRequired" class="required">*</span>
      {{ itemData.title }}
    </p>
    <div class="answer-box">
      <!--      单选       -->
      <template v-if="itemData.type === 'radio'">
        <RadioGroup v-model="itemData.answer">
          <Radio
            v-for="aItem in itemData.options"
            :key="aItem.value"
            :name="aItem.value"
            icon-size="13"
          >
            {{ aItem.title }}
          </Radio>
        </RadioGroup>
      </template>
      <!--      复选      -->
      <template v-if="itemData.type === 'checkbox'">
        <CheckboxGroup v-model="itemData.answer">
          <Checkbox
            v-for="aItem in itemData.options"
            :key="aItem.value"
            :name="aItem.value"
            shape="square"
            icon-size="13"
          >
            {{ aItem.title }}
          </Checkbox>
        </CheckboxGroup>
      </template>
      <!--      上传      -->
      <template v-if="itemData.type === 'upload'">
        <Uploader
          v-model="itemData.fileList"
          name="credentials"
          index="1"
          multiple
          :deletable="false"
          :max-count="itemData.maxCount"
          upload-icon="/static/images/img_upload_icon.png"
          :preview-full-image="true"
          :before-read="handleUploadCredentials"
        >
          <template #preview-cover="file">
            <div class="preview-cover van-ellipsis">
              <div class="left">
                <img
                  src="../../../assets/images/icon_uploader_preview.png"
                  alt=""
                />
              </div>
              <div
                class="right"
                @click.prevent.stop="handleDeleteUploadImg(file)"
              >
                <img
                  src="../../../assets/images/icon_uploader_delete.png"
                  alt=""
                />
              </div>
            </div>
          </template>
        </Uploader>
      </template>
      <!--      多行文本      -->
      <template v-if="itemData.type === 'textarea'">
        <Field
          v-model="itemData.answer"
          type="textarea"
          :placeholder="itemData.placeholder"
        />
      </template>
    </div>
    <p class="tips" v-if="itemData.tips">{{ itemData.tips }}</p>
    <!-- 单选题  选了 否 提示   -->
    <p
      class="isFalseTip"
      v-if="
        itemData.isRequired &&
          itemData.requireTips &&
          itemData.answer == itemData.requireTipsAnswer
      "
    >
      {{ itemData.requireTips }}
    </p>
  </div>
</template>

<script>
import {
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Uploader,
  Field,
  Toast
} from "vant";
export default {
  components: { Radio, RadioGroup, Checkbox, CheckboxGroup, Uploader, Field },
  props: {
    itemData: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  computed:{
    bgColor() {
      return this.$store.getters["common/bgColor"];
    }
  },
  methods: {
    handleUploadCredentials(file) {
      this.uploadLoading = Toast.loading({
        duration: 0,
        forbidClick: true,
        loadingType: "spinner",
        message: `${this.$t("funds.credential.domText[4]")}...`
      });
      return new Promise((resolve, reject) => {
        const params = new FormData();
        if (Array.isArray(file)) {
          for (let i = 0, len = file.length; i < len; i++) {
            params.append(`file[${i}]`, file[i]);
          }
        } else {
          params.append("file[0]", file);
        }
        params.append("put_dir", "gygjqh_money");
        this.$apis
          .myUploadFileMulti(params)
          .then(res => {
            this.uploadLoading && this.uploadLoading.clear();
            res.forEach(item => {
              // 数据格式做一个保障 防止给了 空字符的数据
              if(!this.itemData.answer || this.itemData.answer === ''){
                this.itemData.answer = [];
              }
              if (this.itemData.answer.length < this.itemData.maxCount) {
                this.itemData.answer.push(item.content);
              }
            });
            resolve();
          })
          .catch(() => {
            this.uploadLoading && this.uploadLoading.clear();
            reject();
          });
      });
    },
    handleDeleteUploadImg(file) {
      this.itemData.answer = []
      for (let i = 0, len = this.itemData.fileList.length; i < len; i++) {
        if (this.itemData.fileList[i].content === file.content) {
          this.itemData.fileList.splice(i, 1);
          return true;
        }
      }
      this.itemData.fileList.forEach(item =>{
        if (this.itemData.answer.length < this.itemData.maxCount) {
          this.itemData.answer.push(item.content);
        }
      })
    }
  }
};
</script>

<style scoped lang="less">
.topic-box {
  padding: 0 20px;
  .title {
    font-size: 30px;
    line-height: 44px;
    font-weight: bold;
    margin-bottom: 20px;
    position: relative;
    .required {
      position: absolute;
      left: -20px;
      top: 0;
      color: #ee0a24;
    }
  }
  .answer-box {
    /deep/ .van-radio-group,
    /deep/ .van-checkbox-group {
      display: flex;
      flex-wrap: wrap;
      .van-radio,
      .van-checkbox {
        border: 1px solid #eee;
        padding: 14px 30px 12px 16px;
        margin-right: 30px;
        margin-bottom: 20px;
        font-size: 24px;
        display: flex;
        align-items: center;
        .van-radio__label {
          line-height: 24px;
        }
        //.van-icon{
        //  display: flex;
        //  align-items: center;
        //  justify-content: center;
        //}
      }
      //.van-checkbox{
      //  .van-icon{
      //    &::before{
      //      display: block;
      //      line-height: 0.9em;
      //    }
      //  }
      //}
    }
    /deep/ .van-uploader__upload {
      padding: 16px;
      width: 248px;
      height: 152px;
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      background: url("../../../assets/images/img_upload_bg.png") center center
        no-repeat;
      background-size: cover;
      border-radius: 0;
      .van-icon__image {
        width: 216px;
        height: 120px;
      }
    }
    /deep/ .van-field {
      margin-bottom: 20px;
    }
  }
  .tips {
    font-size: 24px;
    margin-top: 20px;
  }
  .isFalseTip {
    color: #ee0a24;
    font-size: 24px;
    margin-bottom: 20px;
  }
  /deep/ .van-uploader__wrapper {
    width: 100%;
    justify-content: space-between;
  }
  /deep/ .van-uploader__preview {
    width: 248px;
    height: 152px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: url("../../../assets/images/img_upload_bg.png") center center
      no-repeat;
    background-size: cover;
  }
  .preview-cover {
    width: 100%;
    height: 100%;
    background-color: rgba(246, 247, 251, 0.75);
    display: flex;
    .left,
    .right {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50%;
    }
    .left {
      img {
        width: 40px;
        height: 40px;
      }
    }
    .right {
      img {
        width: 32px;
        height: 40px;
      }
    }
  }
}

.black-theme{
  /deep/ .van-radio__icon--checked .van-icon{
    background-color: #377CFB !important;
    border-color: #377CFB !important;
  }
}



</style>
